const PHASES = {
  de: { warmup: "Einlaufen", sprint_warmup: "Aufwärmen", run: "Laufen", work: "Intervall", rest: "Pause", sprint: "Sprint", cooldown: "Auslaufen" },
  en: { warmup: "Warm-up", sprint_warmup: "Warm-up", run: "Run", work: "Interval", rest: "Rest", sprint: "Sprint", cooldown: "Cool-down" },
};

/** Only structured upcoming sections may speak; never titles, counts or durations. */
export function cueText(cue, language = "de") {
  if (cue?.type !== "SECTION_ANNOUNCE" || cue.params?.multipleSections !== true) return "";
  const locale = language === "en" ? "en" : "de";
  const kind = cue.params.announcementKind ?? cue.params.kind;
  const phase = typeof kind === "string" && Object.prototype.hasOwnProperty.call(PHASES[locale], kind)
    ? PHASES[locale][kind] : locale === "en" ? "Next section" : "Nächster Abschnitt";
  return `${phase} ${locale === "en" ? "in three" : "in drei"}`;
}

// Punctuation gives local TTS a modest phrase boundary; never speak repetitions.
export function cueSpeechText(cue, language = "de") {
  return cueText(cue, language).replace(/ in (drei|three)$/, ", in, $1.");
}

export function cueRecordingKey(cue) {
  if (cue?.type !== "SECTION_ANNOUNCE" || cue.params?.multipleSections !== true) return null;
  const kind = cue.params.announcementKind ?? cue.params.kind;
  return typeof kind === "string" && Object.prototype.hasOwnProperty.call(PHASES.de, kind) ? kind : "next_section";
}
